import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { environment } from '../../environments/environment';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { log } from 'util';

@Component({
  selector: 'app-print-cus-bill',
  templateUrl: './print-cus-bill.component.html',
  styleUrls: ['./print-cus-bill.component.css']
})
export class PrintCusBillComponent implements OnInit {
  customer_details: any;
  chekoutArray: any;
  model: any = {};
  discount: any = [];
  tot_amt: number;
  Inv_tot: number = 0;
  disAmt: any;
  dataresult: any = [];
  typeOneCategory: {}[];
  multiple_offer: any = [];
  currentUser: any;
  coupons: any;
  applied: number = 0;
  addMinuss2: any;
  addMinuss3: any;
  addMinuss4: any;
  addMinuss5: any;
  offer_coupon: number = 0;
  invoiceTotal: number = 0;
  feedback: boolean = false;
  mOff: boolean = true;
  hideAdd: boolean = false;
  percentof30: number;
  service_offered_id: any;
  currDate: string;
  product_multiple_offer: any = [];
  productsTobuy: any = {};
  bill_no: number = 0;
  billed_on: any;
  full_bill: any = [];
  readcash: number = 0;
  readg_pay: number = 0;
  readcard: number = 0;
  readcheque: number = 0;
  readonline_banking: number = 0;
  readsalary: number = 0;
  readtips: number = 0;
  add_charge: any;
  add_charge_value: Number = 0;
  add_charge_value2: Number = 0;
  add_charge_value3: Number = 0;
  add_charge_value4: Number = 0;
  add_charge_value5: Number = 0;
  add_charge_name: string = '';
  add_charge_name2: string = '';
  add_charge_name3: string = '';
  add_charge_name4: string = '';
  add_charge_name5: string = '';
  fullBill: any;
  MainData: Object;

  constructor(
    private router: Router,
    private activerouter: ActivatedRoute,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _arout: ActivatedRoute,
    private _flashMessagesService: FlashMessagesService

  ) {

    this._arout.params.subscribe(p => {
      this.loginservice.printBill(p['bill_no'], p['customer_id'], this.currentUser)
        .subscribe(
          data => {
            if (data) {
              this.MainData = data;
              this.model = data['model'];
              this.tot_amt = data['tot_amt'];
              this.invoiceTotal = data['invoiceTotal'];
              this.multiple_offer = data['multiple_offer'];
              this.chekoutArray = data['chekoutArray'];
              this.discount = data['discount'];
              this.product_multiple_offer = data['product_multiple_offer'];
              this.productsTobuy = data['productsTobuy'];
              this.bill_no = data['bill_no'];
              this.add_charge = data['add_charge'];
              this.billed_on = data['billed_on'];
              this.model['cash'] = 0;
              this.model['g_pay'] = 0;
              this.model['card'] = 0;
              this.model['tips'] = 0;
              this.model['cheque'] = 0;
              this.model['online_banking'] = 0;
              this.model['salary'] = 0;
              if (this.add_charge.length > 0) {
                this.add_charge_value = this.add_charge[0].add_charge;
                this.add_charge_value2 = this.add_charge[0].add_charge2;
                this.add_charge_value3 = this.add_charge[0].add_charge3;
                this.add_charge_value4 = this.add_charge[0].add_charge4;
                this.add_charge_value5 = this.add_charge[0].add_charge5;
                this.add_charge_name = this.add_charge[0].charge_name;
                this.add_charge_name2 = this.add_charge[0].charge_name2;
                this.add_charge_name3 = this.add_charge[0].charge_name3;
                this.add_charge_name4 = this.add_charge[0].charge_name4;
                this.add_charge_name5 = this.add_charge[0].charge_name5;
              } else {
                this.add_charge_value = 0;
                this.add_charge_value2 = 0;
                this.add_charge_value3 = 0;
                this.add_charge_value4 = 0;
                this.add_charge_value5 = 0;
                this.add_charge_name = '';
                this.add_charge_name2 = '';
                this.add_charge_name3 = '';
                this.add_charge_name4 = '';
                this.add_charge_name5 = '';
              }
              if (data['full_bill']) {
                this.full_bill = data['full_bill']
              } else {
                this.loginservice.full_bill(this.bill_no, this.currentUser).subscribe(
                  data => {
                    this.full_bill = data['comp_details'];
                    this.readcash = data['cash'];
                    this.readg_pay = data['g_pay'];
                    this.readcard = data['card'];
                    this.readtips = data['tips'];
                    this.readcheque = data['cheque'];
                    this.readonline_banking = data['online_banking'];
                    this.readsalary = data['salary'];
                    this.model.cash = data['cash'];
                    this.model.g_pay = data['g_pay'];
                    this.model.card = data['card'];
                    this.model.cheque = data['cheque'];
                    this.model.online_banking = data['online_banking'];
                    this.model.salary = data['salary'];
                    this.model.tips = data['tips'];
                  }, error => { alert('Network Error full_bill API'); });
              }
            }
          }, error => { alert('Network Error params API'); });
    }, error => { alert('Network Error printBill API'); });
  }

  ngOnInit() {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    // Get current date
    var currentDate = new Date();
    // Extract day, month, and year
    var day = currentDate.getDate().toString();
    var month = (currentDate.getMonth() + 1).toString(); // January is 0, so we add 1
    var year = currentDate.getFullYear().toString();
    // Ensure day and month are in two-digit format
    if (day.length < 2) {
      day = '0' + day;
    }
    if (month.length < 2) {
      month = '0' + month;
    }
    // Format the date as "dd-mm-yyyy"
    this.currDate = day + '-' + month + '-' + year;
  }


  paymentMode() {
    let totPay = parseInt(this.model['cash']) + parseInt(this.model['g_pay']) + parseInt(this.model['card']) + parseInt(this.model['cheque']) + parseInt(this.model['online_banking']) + parseInt(this.model['salary'])
    if (this.invoiceTotal + Number(this.add_charge_value) + Number(this.add_charge_value2) + Number(this.add_charge_value3) + Number(this.add_charge_value4) + Number(this.add_charge_value5) == totPay) {
      this.loginservice.savepaymentMode(this.model, this.bill_no, this.currentUser)
        .subscribe(
          data => {
            this._flashMessagesService.show('Payment Mode Saved!', { cssClass: 'alert-success' });
          }, error => { alert('Network Error savepaymentMode API'); });
    } else {
      alert('mis match')
    }
  }

  getDisc(sid, bill_no) {
    for (let i = 0; i < this.full_bill.length; i++) {
      let element = this.full_bill[i];
      if (element.bill_no === bill_no && element.service_desc_id === sid) {
        let reAmnt = ((element.discounted_amount / element.amount1) * 100);
        if (reAmnt > 0) {
          return (Math.floor(reAmnt * 10) / 10).toFixed(1) + '%';
          // return reAmnt + '%';
        } else {
          return null;
        }
      }
    }
    return null;  // Default return value if no matching element is found
  }

  getKeyValues(obj: any, name): { key: string, value: any[] }[] {
    if (obj) {
      return Object.keys(obj).map(key => ({ key, value: obj[key] }));
    } else {
      return this[name] = [];
    }
  }

  convertToWords(number: number): string {
    // Define an array of words for numbers 0 to 19
    const units: string[] = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];

    // Define an array of words for tens multiples
    const tensMultiples: string[] = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    // Define an array of words for powers of thousand
    const tensPowers: string[] = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

    // Function to convert numbers less than 1000 to words
    const convertLessThanOneThousand = (num: number): string => {
      if (num === 0) {
        return '';
      }

      let word = '';

      if (num < 20) {
        word = units[num];
      } else if (num < 100) {
        word = tensMultiples[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + units[num % 10] : '');
      } else {
        word = units[Math.floor(num / 100)] + ' Hundred ' + convertLessThanOneThousand(num % 100);
      }

      return word.trim();
    };

    // Function to recursively convert large numbers to words
    const convertToWordsHelper = (num: number, power: number): string => {
      if (num === 0) {
        return '';
      }

      let word = convertToWordsHelper(Math.floor(num / 1000), power + 1); // Recursive call for higher powers
      let remainder = convertLessThanOneThousand(num % 1000);

      if (remainder) {
        word += (word ? ' ' : '') + remainder + ' ' + tensPowers[power];
      }

      return word.trim();
    };

    // Function to handle the decimal part
    const handleDecimalPart = (num: number): string => {
      let decimalPart = Math.round((num % 1) * 100); // Get the fractional part as an integer (e.g., 79.2 => 20)
      if (decimalPart > 0) {
        if (decimalPart < 20) {
          return ' point ' + units[decimalPart] + ' paisa'; // Convert to words for numbers below 20
        } else {
          return ' point ' + tensMultiples[Math.floor(decimalPart / 10)] + ' ' + (decimalPart % 10 !== 0 ? units[decimalPart % 10] + ' paisa' : 'paisa');
        }
      }
      return '';
    };

    if (number === 0) {
      return 'Rupees Zero Only';
    }

    // Separate the integer part and decimal part
    let integerPart = Math.floor(number);
    let decimalPart = handleDecimalPart(number);

    // Convert the integer part to words and append the decimal part if it exists
    let words = convertToWordsHelper(integerPart, 0).trim();

    // Return the final output with "Rupees" and "paisa" formatting
    return 'Rupees ' + words + decimalPart;
  }

  // public mprint() {
  //   var printContents = document.getElementById('divToPrint').innerHTML;
  //   var originalContents = document.body.innerHTML;
  //   document.body.innerHTML = printContents;
  //   window.print();
  //   document.body.innerHTML = originalContents;
  // }

  public mprint() {
    // var printContents = document.getElementById('divToPrint').innerHTML;
    // var originalContents = document.body.innerHTML;
    // document.body.innerHTML = printContents;
    window.print();

    // Restore the original content after printing
    // setTimeout(() => {
    //   document.body.innerHTML = originalContents;
    // }, 1000); // Adjust the delay time as needed

    // Navigate to the 'print' route after printing
    // this.navigateToPrintRoute();
  }

  private navigateToPrintRoute() {
    alert('ssss')
    this.router.navigate(['print'], {
      queryParams: {
        model: JSON.stringify(this.model),
        tot_amt: JSON.stringify(this.tot_amt),
        invoiceTotal: JSON.stringify(this.invoiceTotal),
        multiple_offer: JSON.stringify(this.multiple_offer),
        chekoutArray: JSON.stringify(this.chekoutArray),
        discount: JSON.stringify(this.discount),
      }
    });
  }
  toNum(add_charge_value) {
    return Number(add_charge_value)
  }

  getBillLogoPath(): string {
    if (this.currentUser && this.currentUser.billLogo) {
      // If salon has custom bill logo, use upload URL
      return `${environment.uploadUrl}uploads/salon_bill_logos/${this.currentUser.billLogo}`;
    }
    // Default logo
    return '';
  }

}




// WEBPACK FOOTER //
// ./src/app/print-cus-bill/print-cus-bill.component.ts